/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react'
import { ContentComponentType } from '@splunk-iteng/splunk-shared-components/dist/lib/Types/ContentComponentType'
import { useIssueAccountActivationLinkMutation } from '../../graphql/graphql'
import { CopyButton } from '../CopyButton/CopyButton'

export function SendActivationLink({
  currentState,
  doSubmit,
  clearState
}: ContentComponentType) {
  const [email, setEmail] = useState(currentState)
  const [localDoSubmit, setLocalDoSubmit] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [successData, setSuccessData] = useState({} as any)
  const [issueAccountActivationLinkMutation] =
    useIssueAccountActivationLinkMutation()
  const [emailHasChanged, setEmailHasChanged] = useState(false)

  useEffect(() => {
    if (currentState.email !== email) {
      setEmail(currentState.email)
      setEmailHasChanged(true)
    }
  }, [email, currentState.email])

  const submit = useCallback(async () => {
    try {
      if (emailHasChanged) {
        setSubmitted(false)
        setSubmitting(true)
        const { data }: any = await issueAccountActivationLinkMutation({
          variables: {
            username: email
          },
          onError: (err) => {
            const message = err.message.search('Must be in email format')
            if (message >= 0) {
              alert('Please provide a value with a valid email format')
            } else {
              alert(err.message)
            }
          }
        })
        setSuccessData(data.issueAccountActivationLink)
        setSubmitting(false)
        setSubmitted(true)
      }
    } catch (error) {
      setSuccessData({})
      setSubmitting(false)
      setSubmitted(true)
    } finally {
      clearState()
    }
  }, [email, emailHasChanged, issueAccountActivationLinkMutation, clearState])

  const btn = (label = 'Send activation url') => (
    <button
      type="button"
      className="mt-20 btn btn-primary"
      onClick={submit}
      disabled={submitting || !email}
    >
      {label}
    </button>
  )

  useEffect(() => {
    if (doSubmit && !localDoSubmit) {
      setLocalDoSubmit(true)
      submit()
    }
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit, submit])

  useEffect(() => {
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit])

  if (submitting) {
    return <div className="pt-20">Issuing activation url...</div>
  }

  if (
    submitted &&
    email &&
    emailHasChanged &&
    (!successData || !successData.activationUrl)
  ) {
    return (
      <div className="pt-20">
        Failed to issue activation url for {email}
        <br />
        {btn('Retry')}
      </div>
    )
  }
  if (submitted && successData && successData.activationUrl) {
    return (
      <>
        <div>{btn('Send another activation url')}</div>
        <div className="row pt-20">
          <div className="col-12">
            User {email} activation url was successfully issued.
            <br />
            <h2 className="mt-20">Activation Url:</h2>
            <input
              type="text"
              className="form-control"
              value={successData.activationUrl}
            />
            <CopyButton text={successData.activationUrl} />
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="pt-20">
      Please enter username to send a activation url.
      <br />
      {btn()}
    </div>
  )
}
